import { Outlet, useParams } from "react-router-dom"
import NotFound from "../../screens/NotFound";

export const CuratorGuard = () => {
  const { type } = useParams();

  if (type !== 'room' && type !== 'project') return <NotFound />

  return <Outlet />
}